<template>
    <div class="basic_wrap mt44">
    
        <baseHeader :title="$t('user.myInvestment')"></baseHeader>
        
        <h3 class="notes_tit">{{ $t('orders.record') }}</h3>
        <van-empty :description="$t('orders.noOrders')" v-if="empty"/>
        <div class="scrollBox">
            <div class="notes_box" v-if="!empty" v-for="i in data.list">
             
                <div class="item_div1">
                    <p>
                        {{ i[lang] }}
                    </p>
                </div>
                <div class="item_div2">
                    <div class="item_min">
                        <p>{{ $t('utils.moneyMark') }}{{ i.money }}</p>
                        <p>{{ $t('utils.investmentAmount') }}</p>
                    </div>
                    <div class="item_rate">
                        <p>{{ $t('utils.moneyMark') }}{{ (i.money * i.rate / 100 * i.day).toFixed(2) }}</p>
                        <p>{{ $t('utils.income') }}</p>
                    </div>
                    <div class="item_day">
                        <p>{{ i.day }}{{ $t('utils.day') }}</p>
                        <p>{{ $t('utils.cycle') }}</p>
                    </div>
                </div>
                <p class="timer">
                    {{ i.timestr }}
                    <span class="ing" v-if="i.next_back_time!=0">{{ $t('orders.unfinish') }}</span>
                    <span class="finish" v-if="i.next_back_time==0">{{ $t('orders.finish') }}</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import {
    Empty
} from "vant";

import Fetch from "../../utils/fetch";
import baseHeader from "@/components/baseHeader";
Vue.use(Empty);

export default {
    name: "order",
    data() {
        return {
            lang: this.$i18n.locale || "zh_cn",
            data: {},
            empty: false,
        };
    },
    components:{
        baseHeader
    },
    created() {
        this.$parent.footer("user", false);
    },
    mounted() {
        this.start();
    },
    methods: {
        start() {
            Fetch("/user/order").then((r) => {
                this.data = r.data;
                r.data.list.length == 0 ?
                    (this.empty = true) :
                    (this.empty = false);
                
                let now = new Date(new Date().toLocaleDateString()).getTime() / 1000 + 3600 * 5.5
                
                
            });
            
        },
        wan(str) {
            var num = parseFloat(str);
            if (num > 99999) {
                return `${(num / 10000).toFixed(2)}万`;
            } else {
                return str || 0;
            }
        },
        lookHT(id) {
            this.$router.push("/contract/" + id);
        },
    },
};
</script>

<style lang="less" scoped>
.red_top_bg {
    height: 156px;
    background: #3775f4;
    background-size: 100% 100%;
    position: fixed;
    z-index: 15;
}


.notes_tit {
    width: 96%;
    line-height: 44px;
    height: 44px;
    font-size: 14px;
    color: #ffffff;
    padding: 0 14px;
    //background: #FAFAFA;
    z-index: 2;
    margin: 0 auto;
    
}

.notes_box {
    width: 100%;
    padding-bottom: 2px;
    background: #2B3864;
    //box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
    border-radius: 8px;
    margin-bottom: 10px;
    
    .timer {
        width: 96%;
        margin: 0 auto;
        padding: 12px 14px;
        font-size: 12px;
        color: #767F9E;
        border-top: 1px solid #3E4E82;
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        span {
            font-style: normal;
            padding: 5px;
            border-radius: 5px;
            color: #FFFFFF;
        }
        
        .ing {
            //background: #3775f4;
            color: #52BE22;
            font-weight: 700;
            font-family: Arial-BoldMT;
            font-size: 0.4rem;
        }
        
        .finish {
            color: #e71966;
            font-weight: 700;
            font-family: Arial-BoldMT;
            font-size: 0.4rem;
        }
    }
    
    .item_div1 {
        display: flex;
        justify-content: space-between;
        padding: 15px 10px;
        
        p:nth-child(1) {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: 700;
            font-size: 0.48rem;
            color: white;
            font-family: Arial-Black;
        }
    }
    
    .item_div2 {
        display: flex;
        justify-content: space-between;
        text-align: center;
        margin-bottom: 10px;
        
        div {
            width: 33.33%;
            
            p {
                padding: 5px 0;
            }
        }
        
        .item_rate {
            p:nth-child(1) {
                font-weight: bold;
                font-size: 0.4rem;
                color: #EB5678;
            }
            
            p:nth-child(2) {
                color: #9BA3C8;
            }
        }
        
        .item_day {
            p:nth-child(1) {
                font-weight: bold;
                font-size: 0.4rem;
                color: #FDD6AD;
            }
            
            p:nth-child(2) {
                color: #9BA3C8;
            }
        }
        
        .item_min {
            p:nth-child(1) {
                font-weight: bold;
                font-size: 0.4rem;
                color: #FDD6AD;
            }
            
            p:nth-child(2) {
                color: #9BA3C8;
            }
        }
    }
}

.scrollBox {
    width: 96%;
    margin: 0 auto;
}
</style>
